import { Component, OnDestroy, OnInit } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { CheckService } from "src/app/_core/providers/check.service";
import { environment } from "src/environments/environment";

// Models

// Services

@Component({
	selector: "app-example-component",
	templateUrl: "./example.component.html",
	styleUrls: ["./example.component.scss"],
})
export class ExampleComponent implements OnInit, OnDestroy {
	respuestaback: string = "";
	respuestabackBD: string = "";
	constructor(private readonly checkservice: CheckService) {}

	// Life-cycle hooks
	async ngOnInit(): Promise<void> {
		// Initialize component - await this.obtenerDatos() when needed
	}

	private async obtenerDatos(): Promise<void> {
		try {
			const resBack = await lastValueFrom(this.checkservice.checkBack());
			if (!environment.production) {
				console.log(resBack);
			}

			// TODO: Process response when needed
		} catch (error) {
			if (!environment.production) {
				console.log(error);
			}
		}
	}

	recargarDatos(): void {
		// Llama a la función para obtener datos nuevamente
		this.obtenerDatos();
	}

	ngOnDestroy(): void {
		// Destroy whatever you have to destroy here.
	}
}
